var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMargin01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 162,
    viewBox: "0 0 155 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.2901 106.55H14.1001V22.5H134.76V106.55H107.17",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M134.76 106.551L146.22 159.601H2L14.1 106.551",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M88.28 137.93L90.96 150.33H57.27L60.09 137.93H88.28Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M92.2402 94.0312L92.4002 135.451L102.25 127.201L111.53 147.051L119.91 142.931L110.99 122.841L123.93 120.911L92.2402 94.0312Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.8602 147.969C45.6002 147.969 45.6002 143.719 42.8602 143.719C40.1202 143.719 40.1202 147.969 42.8602 147.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.47 14.0195C85.21 14.0195 85.21 9.76953 82.47 9.76953C79.73 9.76953 79.73 14.0195 82.47 14.0195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M45.0399 96.1602C47.7799 96.1602 47.7799 91.9102 45.0399 91.9102C42.2999 91.9102 42.2999 96.1602 45.0399 96.1602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M94.8699 37.0898C97.6099 37.0898 97.6099 32.8398 94.8699 32.8398C92.1299 32.8398 92.1299 37.0898 94.8699 37.0898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.2301 12.72C32.1903 12.72 34.5901 10.3202 34.5901 7.36C34.5901 4.39975 32.1903 2 29.2301 2C26.2699 2 23.8701 4.39975 23.8701 7.36C23.8701 10.3202 26.2699 12.72 29.2301 12.72Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M147.81 105.98C150.77 105.98 153.17 103.58 153.17 100.62C153.17 97.6595 150.77 95.2598 147.81 95.2598C144.85 95.2598 142.45 97.6595 142.45 100.62C142.45 103.58 144.85 105.98 147.81 105.98Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.9502 84.6999V29.4199H76.2302",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M74.8198 84.4087V56.9688",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M59.27 61.1186L74.82 45.5586L90.38 61.1186",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin01);
export default __webpack_public_path__ + "static/media/icon_margin_01.20abc8155455d274cea9fdd8bb2cb950.svg";
export { ForwardRef as ReactComponent };